var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.stats),function(stat,i){return _c('bar-chart-entry',{key:("stat-" + i),attrs:{"element-map":_vm.elementMap,"stat":stat,"color-from-name":_vm.colorFromName,"border":_vm.border,"not-found-name":_vm.notFoundName}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }